import { render } from "./SettingsView.vue?vue&type=template&id=5e71a416&scoped=true"
import script from "./SettingsView.vue?vue&type=script&lang=js"
export * from "./SettingsView.vue?vue&type=script&lang=js"

import "./SettingsView.vue?vue&type=style&index=0&id=5e71a416&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e71a416"]])

export default __exports__